import ProductType from "@/models/Products/ProductType";
import ProductSubType from "@/models/Products/ProductSubType";
import TargetCustomerType from "@/models/Products/TargetCustomerType";

export default class ProductGeneralSettings {
    name: string = '';
    code: string = '';
    description: string = '';
    legacyId: string = '';
    type: ProductType;
    subType: ProductSubType;
    targetCustomerType: TargetCustomerType = TargetCustomerType.Commercial;
    defaultWalletCurrency: string = 'GBP';
}